// src/components/ItemList.js
import React from 'react';
// ✅ STEP 1: Import the useNavigate hook
import { useNavigate } from 'react-router-dom';
import PaginationControls from './PaginationControls';
import { ItemNotificationIndicator } from './SmartNotificationDot';
import { getStatusLabel } from '../utils/statusUtils';

const ROWS_PER_PAGE = 10;

// ✅ STEP 2: Remove the `Maps` prop from the function definition
const ItemList = ({ items = [], currentPage, onPageChange, notifications = [] }) => {
    // ✅ STEP 3: Initialize the navigate function from the hook
    const navigate = useNavigate();
    const totalPages = Math.ceil(items.length / ROWS_PER_PAGE);
    const paginatedItems = items.slice((currentPage - 1) * ROWS_PER_PAGE, currentPage * ROWS_PER_PAGE);

    return (
        <div>
            <div className="space-y-4">
                {paginatedItems.length > 0 ? paginatedItems.map(item => (
                    <div key={item.id} className="bg-white p-3 sm:p-4 rounded-lg shadow-md flex flex-col sm:flex-row items-start sm:items-center sm:justify-between space-y-3 sm:space-y-0">
                        <div className="flex items-center w-full relative">
                            <div className="relative">
                                <img
                                    src={item.thumbUrls?.[0] || item.imageUrls?.[0] || 'https://placehold.co/100x100/e2e8f0/64748b?text=Item'}
                                    alt={item.title}
                                    loading="lazy" decoding="async" width="64" height="64"
                                    className="w-14 h-14 sm:w-16 sm:h-16 object-cover rounded-md mr-3 sm:mr-4"
                                />
                                <ItemNotificationIndicator itemId={item.id} notifications={notifications} />
                            </div>
                            <div className="flex-grow">
                                <p className="font-semibold text-sm sm:text-base">{item.title}</p>
                                <p className="text-xs sm:text-sm text-gray-500">
                                    {item.credits} C -
                                    <span className={`font-medium ${item.status === 'available' ? 'text-green-500' : 'text-yellow-500'}`}>
                                        {` ${getStatusLabel(item.status)}`}
                                    </span>
                                </p>
                            </div>
                        </div>
                        {/* ✅ STEP 4: Update the onClick handler to use the correct dynamic route */}
                        <button 
                            onClick={() => navigate(`/edit-item/${item.id}`)} 
                            className="text-sm text-blue-600 hover:underline self-end sm:self-center"
                        >
                            Editar
                        </button>
                    </div>
                )) : (
                    <div className="text-center py-12">
                         <p className="text-gray-500 text-lg font-medium">Nenhum item anunciado</p>
                         <p className="text-gray-400 text-sm mt-1">Seus anúncios aparecerão aqui</p>
                    </div>
                )}
            </div>
            <PaginationControls currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
        </div>
    );
};

export default ItemList;

